export default "__VITE_ASSET__FLkHGtVc__"